export default "__VITE_ASSET__fdbcc4dd__"